import React from "react";

const MobileFooter = () => (
  <footer className="mobile-app-footer" aria-label="SUPROL">
    <p className="mobile-app-footer__brand">SUPROL</p>
    <p className="mobile-app-footer__tagline">World Class Spectacle Lenses</p>
    <p className="mobile-app-footer__meta">OMS</p>
  </footer>
);

export default MobileFooter;
